export const allowedBondLoanPrograms = [
  'vhda bond conv 30yrfx bond',
  'vhda bond fha 30yrfx bond',
  'vhda bond usda 30yrfx bond',
  'vhda bond va 30yrfx bond',
  'vhda conv 30yrfx bond',
  'vhda dpa plus 2nd mtg 30yrfx bond',
  'vhda fha 30yrfx bond',
  'vhda va 30yrfx bond',
];
